<template>
  <div style="height: 100%; position: absolute;">
    <ob-modal2 :backdrop="false" width="100%" :show.sync="previewPopup" size="modal-body-full">
      <template slot="modal-title">{{modalTitle}}</template>
      <template slot="modal-body">
        <!-- <div style="height:100%;overflow-y: scroll">
          <iframe :src="iframeURL" scrolling="yes" style="width:100%;position:relative;height:100%"></iframe>
        </div> -->
         <object :data="iframeURL" type="application/pdf"  style="width:100%;position:relative;height:100%">
           <a :href="iframeURL">{{iframeURL}}</a>
        </object>
      </template>
      <template slot="modal-footer">
        <button type="button" class="btn btn-secondary" @click="previewPopup = false">Cancel</button>
        <button type="button" class="btn btn-primary" @click="onSave">Save</button>
      </template>
    </ob-modal2>
  </div>
</template>

<script>
  export default {
    props: ["openModal", "previewURL", "previewSectionType"],
    data() {
      return {
        previewPopup: false,
        iframeURL: '',
      }

    },
    computed: {
        modalTitle() {
            if(this.previewSectionType == 'Employer')
            {
                return 'Preview Employer Information';
            }
            else if(this.previewSectionType == 'AssignedTraining')
            {
                return 'Preview Training Plan';
            }
            else if(this.previewSectionType == 'Student')
            {
                return 'Preview Student Information';
            }
            else if(this.previewSectionType == 'Evaluation')
            {
                return 'Preview Student Evaluation';
            }
            return 'Preview I-983';
        }
    },
    watch: {
      openModal(val) {
          this.previewPopup = val;
          if (val === true) { // On Modal Open
            this.iframeURL = this.previewURL;
          } else {
            this.iframeURL = '';
          }
        },
        previewPopup(val) {
          this.$emit('update:openModal', val)
        },
    },
    created() {
      this.previewPopup = this.openModal;
    },
    methods: {
      onSave() {
        this.$parent.savePreview(this.previewSectionType)
      },
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/ESSProfile/FormI983/PreviewPdf.vue